/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';
//current Quarter
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter

const formattedQuarter = currentQuarter + 'Q' + currentYear.toString();
const initialState = {
  performResolutionObj: {},
  planType: [],
  selectedPlanType: '',
  rebateProgram: [],
  rebateProgramName: {},
  errorMsgProvider: [],
  provider: [],
  quarter: formattedQuarter,
  referenceData: [],
  displayObj: {
    rebateProgramName: {},
    quarter: formattedQuarter,
    provider: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_PROVIDER:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_PROVIDER:
      return { ...state, errorMsgProvider: action.payload };

    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_LIST_PROVIDER:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.GET_REBATE_PROGRAM_NAME_PROVIDER:
      return { ...state, rebateProgramName: action.payload };
    case actionTypes.GET_FROM:
      return { ...state, quarter: action.payload };
    case actionTypes.GET_PROVIDER:
      let displayObj = {
        ...state.displayObj,
        provider: action.payload,
      };
      return { ...state, provider: action.payload, displayObj };
    case actionTypes.SET_DISPLAY_OBJ_PROVIDER:
      let tempObj = JSON.parse(JSON.stringify(action.payload));
      return { ...state, displayObj: tempObj };
    case actionTypes.GET_REFERENCE_DATA_PROVIDER_CLAIMS:
      return { ...state, referenceData: action.referenceData };
    case actionTypes.SET_REFRESH_DATA_PROVIDER:
      return {
        ...state,
        performResolutionObj: {},
        planType: [],
        selectedPlanType: '',
        rebateProgram: [],
        rebateProgramName: {},
        errorMsgProvider: [],
        provider: [],
        quarter: formattedQuarter,
      };
      case actionTypes.SET_REFRESH_DATA_PROVIDER_DISPLAY:
        return {
          ...state,
          displayObj: initialState.displayObj,
        };
    default:
      return state;
  }
};

export default reducer;
